export default "__VITE_PUBLIC_ASSET__4531e79d__"